export const OrganizationsStore = {
    namespaced: true,
    state: {
        organizations: [],
        organization: {}
    },
    mutations: {
        setOrganizations(state: any, response: any) {
            state.organizations = response;
        },

        setOrganization(state: any, response: any) {
            state.organization = response;
        }
    },
    actions: {
        setOrganizations(context: any, response: any) {
            context.commit('setOrganizations', response);
        },

        setOrganization(context: any, response: any) {
            context.commit('setOrganization', response);
        }
    },
    getters: {
        getOrganizations: (state: any) => state.organizations,
        getOrganization: (state: any) => state.organization
    },
};